class ProductGridMedia extends HTMLElement {
    constructor() {
      super();
  
      const slider = this.querySelector('[data-slider]');
      if (!slider) return;
  
      const flkty = new Flickity(slider, {
        wrapAround: true,
        pageDots: false,
        on: {
          ready: function() {
            this.resize();
          }
        }
      });
      flkty.resize();
  
      const observer = new IntersectionObserver(([ entry ], observer) => {
        if (entry.isIntersecting) {
          flkty.resize();
        }
      }, {rootMargin: '0px', threshold: 1.0});
  
      observer.observe(slider);
    }
  }
  
  customElements.define('product-grid-media', ProductGridMedia);
